import React, { useEffect, useMemo, useState, Fragment, useRef } from "react";


import axios from '../apiClient'
import { aggregateStatementReport } from "./ledgerMath";
import TermMultiSelect from "./TermMultiSelect";

const Settlements = () => {
    const [loading, setLoading] = useState(false);
    const [statement, setStatement] = useState([]);
      const [orgData, setOrgData] = useState([]);
    const [subTotal, setSubTotal] = useState(null);
    const selectedTermsRef = useRef([]);

    const [termOptions, setTermOptions] = useState([]);
    const [selectedTerms, setSelectedTerms] = useState([]);
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState("");
    const [agentDiscount, setAgentDiscount] = useState(false);
    const [toPay, setToPay] = useState(false);
    const [toReceive, setToReceive] = useState(false);
    const [isDetail, setIsDetail] = useState(false);

    // Add CSS for hiding scrollbars
    useEffect(() => {
        const style = document.createElement('style');
        style.textContent = `
            .scrollbar-hide {
                -ms-overflow-style: none;
                scrollbar-width: none;
            }
            .scrollbar-hide::-webkit-scrollbar {
                display: none;
            }
        `;
        document.head.appendChild(style);
        
        return () => {
            document.head.removeChild(style);
        };
    }, []);

    

    // Update ref when selectedTerms changes
    useEffect(() => {
        selectedTermsRef.current = selectedTerms;
    }, [selectedTerms]);
      useEffect(() => {
    fetchTerms()
  }, []);

  async function fetchTerms() {
    try {
      let data = await axios.get(`/bet/getTerms?current=1&limit=1000`);
      if (data.code == 200 && data?.data && data.data?.by) {
        const groupedTerms = {};
            data.data?.by.forEach((term) => {
                const groupId = term.groupId || 'ungrouped';
                if (!groupedTerms[groupId]) {
                    groupedTerms[groupId] = [];
                }
                groupedTerms[groupId].push({
                    value: term.termId,
                    label: `${term.termName}`,
                    groupId: groupId,
                    startDate: term.startDate,
                    endDate: term.endDate,
                    termName: term.termName
                });
            });

            // Convert to React Select grouped options format
            const options = Object.keys(groupedTerms).map(groupId => {
                let groupLabel = 'Ungrouped Terms';
                if (groupId !== 'ungrouped') {
                    const items = groupedTerms[groupId];
                    const {startDate, endDate, termName} = items[0];
                    
                    if (startDate && endDate && termName) {
                        const startDates = items.map(
                            item => new Date(item.startDate),
                        );
                        const endDates = items.map(
                            item => new Date(item.endDate),
                        );
                        const minStart = new Date(Math.min(...startDates));
                        const maxEnd = new Date(Math.max(...endDates));
                        const pad = n => n.toString().padStart(2, '0');
                        const startDay = pad(minStart.getDate());
                        const endDay = pad(maxEnd.getDate());
                        const month = pad(maxEnd.getMonth() + 1);
                        const year = maxEnd.getFullYear();
                        groupLabel = `${startDay} TO ${endDay}/${month}/${year}`;
                    } else {
                        groupLabel = `Group ${groupId}`;
                    }
                }
                
                return {
                    label: groupLabel,
                    options: groupedTerms[groupId]
                };
            });

            setTermOptions(options);
      } else {
      }
    } catch (error) {
      console.error('Error fetching terms:', error);
    }
  }
    const addList=(_data,toPay,toReceive)=>{
        const data = aggregateStatementReport(_data,'owner');
          
          let tmpData = [];
          if (toPay && !toReceive) {
            data.map((row, index) => {
              if (row.SubTotalAmount < 0) {
                tmpData.push(row);
              }
            });
          } else if (toReceive && !toPay) {
            data.map((row, index) => {
              if (row.SubTotalAmount > 0) {
                tmpData.push(row);
              }
            });
          } else {
            tmpData = data;
          }
          const filteredArr = addCustomerTotals(tmpData).filter(x => x.isTotal == true);
          console.log(filteredArr)
          setStatement(filteredArr);
  }
  function addCustomerTotals(data) {
    const numericFields = [
      'SubTotalAmount',
      'TotalAmountWithDiscount',
      'TotalAmountWithPrize',
      'TotalAmountWithoutDiscount',
      'TotalTAmountWithoutPrize',
      'TotalUnitWithDiscount',
      'TotalWinAmountWithoutPrize',
      'discountAmount',
    ];

    // Group by customer
    const grouped = {};
    for (const item of data) {
      if (!grouped[item.customer]) grouped[item.customer] = [];
      grouped[item.customer].push(item);
    }

    // Build the new array with totals
    const result = [];

    for (const [customer, entries] of Object.entries(grouped)) {
      result.push(...entries);

      // Compute totals
      const totalRow = {
        customer: `${customer}`,
        isTotal: true,
        userId: entries.length > 0 ? entries[0].userId : null,
      };

      for (const field of numericFields) {
        const total = entries.reduce((sum, entry) => {
          const val = parseFloat(entry[field]);
          return sum + (isNaN(val) ? 0 : val);
        }, 0);
        totalRow[field] = total.toFixed(2);
      }

      // Add a placeholder for clarity
      totalRow.termName = '';
      result.push(totalRow);
    }

    return result;
  }
  useEffect(() => {
    const fetchStatements = async () => {
  if (selectedTerms.length === 0) {
    setStatement([]);
    setOrgData([]);
    return;
  }

  try {
    setLoading(true);

    const userObj = users.find((user) => user.value == selectedUser);
    const selectedUserType = userObj?.userType || "";

    const termIds = selectedTerms.map(term => term.value);
    const batchSize = 3;

    // Split termIds into chunks
    const chunks = [];
    for (let i = 0; i < termIds.length; i += batchSize) {
      chunks.push(termIds.slice(i, i + batchSize));
    }

    let allData = [];

    // Use for...of loop to await each API call one-by-one
    for (const chunk of chunks) {
      const termIdQuery = chunk.join(",");
      const url = `/bet/getStatementReportEasi?termId=${termIdQuery}&userId=${selectedUser}&userType=${selectedUserType}`;

      const response = await axios.get(url);

      if (response.code === "200" && Array.isArray(response.data)) {
        allData = allData.concat(response.data);
      } else {
        console.warn("One batch failed or returned unexpected data.");
      }
    }

    if (allData.length > 0) {
      setOrgData(allData);
      addList(allData, toPay, toReceive, agentDiscount);
    } else {
      setStatement([]);
      setOrgData([]);
    }

  } catch (error) {
    console.error("Error fetching statements:", error);
  } finally {
    setLoading(false);
  }
};
    
        fetchStatements();
  },[selectedTerms, selectedUser])
    // // Fetch statements based on selected terms and user
    // useDebouncedEffect(() => {
        
    // }, 0, [selectedTerms, selectedUser]);

        useEffect(() => {
            if (selectedTerms.length > 0) {
            addList(
                orgData,
                toPay,
                toReceive,
                agentDiscount,
            );
            }
        }, [toPay, toReceive, agentDiscount]); //selectedItems,selectedUser,
    // Calculate totals
    useEffect(() => {
        if (statement.length > 0) {
            const totals = statement.reduce(
                (acc, row) => {
                    acc.discountAmount += parseFloat(row.discountAmount || "0");
                    acc.TotalAmountWithDiscount += parseFloat(row.TotalAmountWithDiscount || "0");
                    acc.TotalAmountWithoutDiscount += parseFloat(row.TotalAmountWithoutDiscount || "0");
                    acc.TotalWinAmountWithoutPrize += parseFloat(row.TotalWinAmountWithoutPrize || "0");
                    acc.TotalTAmountWithoutPrize += parseFloat(row.TotalTAmountWithoutPrize || "0");
                    acc.TotalAmountWithTPrize += parseFloat(row.TotalAmountWithTPrize || "0");
                    acc.TotalAmountWithPrize += parseFloat(row.TotalAmountWithPrize || "0");
                    acc.SubTotalAmount += parseFloat(row.SubTotalAmount || "0");
                    acc.TotalUnitWithDiscount+= parseFloat(row.TotalUnitWithDiscount || "0");
                    return acc;
                },
                {
                    discountAmount: 0,
                    TotalAmountWithDiscount: 0,
                    TotalAmountWithoutDiscount: 0,
                    TotalWinAmountWithoutPrize: 0,
                    TotalTAmountWithoutPrize: 0,
                    TotalAmountWithTPrize: 0,
                    TotalAmountWithPrize: 0,
                    SubTotalAmount: 0,
                    TotalUnitWithDiscount:0
                }
            );
            setSubTotal(totals);
            
        } else {
            setSubTotal(null);
        }
    }, [statement]);
    const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });

    const groupedStatements = useMemo(() => {
        const grouped = {};
        statement.forEach((row) => {
            const customer = row.customer || "Unknown";
            if (!grouped[customer]) {
                grouped[customer] = [];
            }
            grouped[customer].push(row);
        });
        return grouped;
    }, [statement]);
    

    return (
        <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            gap: '8px', 
            padding: '16px' 
        }}>
            <div style={{ 
                backgroundColor: 'white', 
                padding: '16px', 
                borderRadius: '6px', 
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)', 
                display: 'flex', 
                gap: '16px', 
                alignItems: 'flex-start' 
            }}>
                {/* Multi-select for Terms */}
                <div style={{ width: '40%' }}>
                    <TermMultiSelect
                        data={termOptions.map(group => ({
                            id: group.label,
                            label: group.label,
                            children: group.options.map(option => ({
                                id: option.value,
                                label: option.label
                            }))
                        }))}
                        selectedItems={selectedTerms.map(term => term.value)}
                        onSelectedItemsChange={(selectedIds) => {
                            const newSelectedTerms = selectedIds.map(id => {
                                // Find the term details from termOptions
                                for (const group of termOptions) {
                                    const option = group.options.find(opt => opt.value === id);
                                    if (option) {
                                        return {
                                            value: option.value,
                                            label: option.label,
                                            groupId: group.label
                                        };
                                    }
                                }
                                return null;
                            }).filter(Boolean);
                            
                            setSelectedTerms(newSelectedTerms);
                        }}
                        placeholder="အပါတ်စဉ်များရွေးချယ်ပါ"
                        onOk={() => {
                            // ဒီနားက လဲ confim api ခေါ်လို့ရတယ်
                            // ခုက useEffect နဲ့ သုံးထားတာမို့လို့ ဒီနားမှာ API call မလို
                            console.log("Terms confirmed:", selectedTerms);
                        }}
                    />
                </div>

                {/* <div style={{ 
                    marginTop: '8px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '8px' 
                }}>
                    <input
                        type="checkbox"
                        checked={agentDiscount}
                        disabled={loading}
                        onChange={(e) => setAgentDiscount(e.target.checked)}
                        id="gent-discount"
                        style={{ 
                            height: '16px', 
                            width: '16px', 
                            accentColor: '#3b82f6' 
                        }}
                    />
                    <label htmlFor="gent-discount" style={{ 
                        fontSize: '14px', 
                        color: '#666' 
                    }}>
                        ကိုယ်စားလှယ်ကော်
                    </label>
                </div> */}

                <div style={{ 
                    marginTop: '8px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '8px' 
                }}>
                    <input
                        type="checkbox"
                        checked={toReceive}
                        disabled={loading}
                        onChange={(e) => setToReceive(e.target.checked)}
                        id="to-receive"
                        style={{ 
                            height: '16px', 
                            width: '16px', 
                            accentColor: '#3b82f6' 
                        }}
                    />
                    <label htmlFor="to-receive" style={{ 
                        fontSize: '14px', 
                        color: '#666' 
                    }}>
                        ရရန်
                    </label>
                </div>
                <div style={{ 
                    marginTop: '8px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '8px' 
                }}>
                    <input
                        type="checkbox"
                        checked={toPay}
                        disabled={loading}
                        onChange={(e) => setToPay(e.target.checked)}
                        id="to-pay"
                        style={{ 
                            height: '16px', 
                            width: '16px', 
                            accentColor: '#3b82f6' 
                        }}
                    />
                    <label htmlFor="to-pay" style={{ 
                        fontSize: '14px', 
                        color: '#666' 
                    }}>
                        ပေးရန်
                    </label>
                </div>
            </div>

            {/* Data Table */}
            <div style={{ 
                backgroundColor: 'white', 
                padding: '16px', 
                borderRadius: '6px', 
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)' 
            }}>
                {loading && <div style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    height: '160px' 
                }}>
                    <div style={{
                        width: '40px',
                        height: '40px',
                        border: '4px solid #f3f3f3',
                        borderTop: '4px solid #3b82f6',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite'
                    }}></div>
                </div>}

                {!loading && (
                    <>
                        {isDetail ? (
                            // Detailed view - current logic
                            Object.keys(groupedStatements).map((customer, idx) => {
                                const rows = groupedStatements[customer];
                                
                                const subtotal = rows.reduce(
                                    (acc, row) => {
                                        acc.discountAmount += parseFloat(row.discountAmount || "0");
                                        acc.TotalAmountWithDiscount += parseFloat(row.TotalAmountWithDiscount || "0");
                                        acc.TotalAmountWithoutDiscount += parseFloat(row.TotalAmountWithoutDiscount || "0");
                                        acc.TotalWinAmountWithoutPrize += parseFloat(row.TotalWinAmountWithoutPrize || "0");
                                        acc.TotalTAmountWithoutPrize += parseFloat(row.TotalTAmountWithoutPrize || "0");
                                        acc.TotalAmountWithTPrize += parseFloat(row.TotalAmountWithTPrize || "0");
                                        acc.TotalAmountWithPrize += parseFloat(row.TotalAmountWithPrize || "0");
                                        acc.SubTotalAmount += parseFloat(row.SubTotalAmount || "0");
                                        acc.TotalUnitWithDiscount += parseFloat(row.TotalUnitWithDiscount || "0");
                                        return acc;
                                    },
                                    {
                                        discountAmount: 0,
                                        TotalAmountWithDiscount: 0,
                                        TotalAmountWithoutDiscount: 0,
                                        TotalWinAmountWithoutPrize: 0,
                                        TotalTAmountWithoutPrize: 0,
                                        TotalAmountWithTPrize: 0,
                                        TotalAmountWithPrize: 0,
                                        SubTotalAmount: 0,
                                        TotalUnitWithDiscount: 0,
                                    }
                                );

                                return (
                                    <div key={customer} style={{ marginBottom: '24px' }}>
                                        <div style={{ overflowX: 'auto' }}>
                                            <table style={{ 
                                                minWidth: '100%', 
                                                backgroundColor: 'white', 
                                                border: '1px solid #e5e7eb', 
                                                borderCollapse: 'collapse' 
                                            }}>
                                                {idx === 0 && (
                                                    <thead>
                                                        <tr>
                                                            <th style={{ 
                                                                width: '120px', 
                                                                padding: '8px 16px', 
                                                                borderBottom: '1px solid #e5e7eb', 
                                                                backgroundColor: '#f3f4f6', 
                                                                textAlign: 'left', 
                                                                color: '#6b7280',
                                                                fontWeight: '600'
                                                            }}>ထိုးသား</th>
                                                            <th style={{ 
                                                                width: '120px', 
                                                                padding: '8px 16px', 
                                                                borderBottom: '1px solid #e5e7eb', 
                                                                backgroundColor: '#f3f4f6', 
                                                                textAlign: 'right', 
                                                                color: '#6b7280',
                                                                fontWeight: '600'
                                                            }}>ရောင်းကြေး(ယူနစ်)</th>
                                                            <th style={{ 
                                                                width: '140px', 
                                                                padding: '8px 16px', 
                                                                borderBottom: '1px solid #e5e7eb', 
                                                                backgroundColor: '#f3f4f6', 
                                                                textAlign: 'right', 
                                                                color: '#6b7280',
                                                                fontWeight: '600'
                                                            }}>ရောင်းကြေး(ငွေ)</th>
                                                            <th style={{ 
                                                                width: '100px', 
                                                                padding: '8px 16px', 
                                                                borderBottom: '1px solid #e5e7eb', 
                                                                backgroundColor: '#f3f4f6', 
                                                                textAlign: 'right', 
                                                                color: '#6b7280',
                                                                fontWeight: '600'
                                                            }}>ကော်</th>
                                                            <th style={{ 
                                                                width: '140px', 
                                                                padding: '8px 16px', 
                                                                borderBottom: '1px solid #e5e7eb', 
                                                                backgroundColor: '#f3f4f6', 
                                                                textAlign: 'right', 
                                                                color: '#6b7280',
                                                                fontWeight: '600'
                                                            }}>ကော်နှုတ်ပြီး</th>
                                                            <th style={{ 
                                                                width: '140px', 
                                                                padding: '8px 16px', 
                                                                borderBottom: '1px solid #e5e7eb', 
                                                                backgroundColor: '#f3f4f6', 
                                                                textAlign: 'right', 
                                                                color: '#6b7280',
                                                                fontWeight: '600'
                                                            }}>2D(3D)</th>
                                                            <th style={{ 
                                                                width: '140px', 
                                                                padding: '8px 16px', 
                                                                borderBottom: '1px solid #e5e7eb', 
                                                                backgroundColor: '#f3f4f6', 
                                                                textAlign: 'right', 
                                                                color: '#6b7280',
                                                                fontWeight: '600'
                                                            }}>လျော်ကြေး</th>
                                                            <th style={{ 
                                                                width: '120px', 
                                                                padding: '8px 16px', 
                                                                borderBottom: '1px solid #e5e7eb', 
                                                                backgroundColor: '#f3f4f6', 
                                                                textAlign: 'right', 
                                                                color: '#6b7280',
                                                                fontWeight: '600'
                                                            }}>ရ/ပေး</th>
                                                            <th style={{ 
                                                                width: '120px', 
                                                                padding: '8px 16px', 
                                                                borderBottom: '1px solid #e5e7eb', 
                                                                backgroundColor: '#f3f4f6', 
                                                                textAlign: 'center', 
                                                                color: '#6b7280',
                                                                fontWeight: '600',
                                                                whiteSpace: 'normal',
                                                                wordBreak: 'break-words'
                                                            }}>အပါတ်စဉ်</th>
                                                        </tr>
                                                    </thead>
                                                )}
                                            <tbody>
                                                {rows.map((row, index) => (
                                                    <tr key={index} style={{ textAlign: 'right' }}>
                                                        <td style={{ 
                                                            width: '120px', 
                                                            padding: '8px 16px', 
                                                            borderBottom: '1px solid #e5e7eb', 
                                                            textAlign: 'left', 
                                                            color: '#111827',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '8px'
                                                        }}>{row.customer}
                                                        </td>
                                                        <td style={{ width: '120px', padding: '8px 16px', borderBottom: '1px solid #e5e7eb' }}>{formatter.format(row.TotalUnitWithDiscount)}</td>
                                                        <td style={{ width: '140px', padding: '8px 16px', borderBottom: '1px solid #e5e7eb' }}>{formatter.format(row.TotalAmountWithDiscount)}</td>
                                                        <td style={{ width: '100px', padding: '8px 16px', borderBottom: '1px solid #e5e7eb' }}>{formatter.format(row.discountAmount)}</td>
                                                        <td style={{ width: '140px', padding: '8px 16px', borderBottom: '1px solid #e5e7eb' }}>{formatter.format(row.TotalAmountWithoutDiscount)}</td>
                                                        <td style={{ width: '140px', padding: '8px 16px', borderBottom: '1px solid #e5e7eb' }}>{formatter.format(row.TotalWinAmountWithoutPrize)}({formatter.format(row.TotalTAmountWithoutPrize)})</td>
                                                        <td style={{ width: '140px', padding: '8px 16px', borderBottom: '1px solid #e5e7eb' }}>{formatter.format(row.TotalAmountWithPrize)}</td>
                                                        <td style={{ 
                                                            width: '120px', 
                                                            padding: '8px 16px', 
                                                            borderBottom: '1px solid #e5e7eb',
                                                            color: row.SubTotalAmount < 0 ? '#dc2626' : '#16a34a'
                                                        }}>{formatter.format(row.SubTotalAmount)}</td>
                                                        <td style={{ 
                                                            width: '120px', 
                                                            padding: '8px 16px', 
                                                            borderBottom: '1px solid #e5e7eb', 
                                                            textAlign: 'center',
                                                            whiteSpace: 'normal',
                                                            wordBreak: 'break-words',
                                                            overflow: 'hidden'
                                                        }}>{row.termName}</td>
                                                    </tr>
                                                ))}
                                                {/* Per-customer Total Row */}
                                                <tr style={{ textAlign: 'right' }}>
                                                    <td style={{ 
                                                        width: '120px', 
                                                        padding: '8px 16px', 
                                                        borderBottom: '1px solid #e5e7eb', 
                                                        color: '#030712', 
                                                        textAlign: 'left', 
                                                        fontSize: '14px', 
                                                        fontWeight: '600' 
                                                    }}></td>
                                                    <td style={{ 
                                                        width: '120px', 
                                                        padding: '8px 16px', 
                                                        borderBottom: '1px solid #e5e7eb', 
                                                        color: '#030712', 
                                                        fontSize: '14px', 
                                                        fontWeight: '600' 
                                                    }}>{formatter.format(subtotal.TotalUnitWithDiscount)}</td>
                                                    <td style={{ 
                                                        width: '140px', 
                                                        padding: '8px 16px', 
                                                        borderBottom: '1px solid #e5e7eb', 
                                                        color: '#030712', 
                                                        fontSize: '14px', 
                                                        fontWeight: '600' 
                                                    }}>{formatter.format(subtotal.TotalAmountWithDiscount)}</td>
                                                    <td style={{ 
                                                        width: '100px', 
                                                        padding: '8px 16px', 
                                                        borderBottom: '1px solid #e5e7eb', 
                                                        color: '#030712', 
                                                        fontSize: '14px', 
                                                        fontWeight: '600' 
                                                    }}>{formatter.format(subtotal.discountAmount)}</td>
                                                    <td style={{ 
                                                        width: '140px', 
                                                        padding: '8px 16px', 
                                                        borderBottom: '1px solid #e5e7eb', 
                                                        color: '#030712', 
                                                        fontSize: '14px', 
                                                        fontWeight: '600' 
                                                    }}>{formatter.format(subtotal.TotalAmountWithoutDiscount)}</td>
                                                    <td style={{ 
                                                        width: '140px', 
                                                        padding: '8px 16px', 
                                                        borderBottom: '1px solid #e5e7eb', 
                                                        color: '#030712', 
                                                        fontSize: '14px', 
                                                        fontWeight: '600' 
                                                    }}>{formatter.format(subtotal.TotalWinAmountWithoutPrize)}({formatter.format(subtotal.TotalTAmountWithoutPrize)})</td>
                                                    <td style={{ 
                                                        width: '140px', 
                                                        padding: '8px 16px', 
                                                        borderBottom: '1px solid #e5e7eb', 
                                                        color: '#030712', 
                                                        fontSize: '14px', 
                                                        fontWeight: '600' 
                                                    }}>{formatter.format(subtotal.TotalAmountWithPrize)}</td>
                                                    <td style={{ 
                                                        width: '120px', 
                                                        padding: '8px 16px', 
                                                        borderBottom: '1px solid #e5e7eb', 
                                                        fontSize: '14px', 
                                                        fontWeight: '600' 
                                                    }}>{formatter.format(subtotal.SubTotalAmount)}</td>
                                                    <td style={{ 
                                                        width: '120px', 
                                                        padding: '8px 16px', 
                                                        borderBottom: '1px solid #e5e7eb', 
                                                        fontSize: '14px', 
                                                        fontWeight: '600', 
                                                        textAlign: 'center' 
                                                    }}></td>
                                                </tr>
                                            </tbody>
                                            </table>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            // Simplified view - only subtotals and overall total
                            <div style={{ overflowX: 'auto' }}>
                                <table style={{ 
                                    minWidth: '100%', 
                                    backgroundColor: 'white', 
                                    border: '1px solid #e5e7eb', 
                                    borderCollapse: 'collapse' 
                                }}>
                                    <thead>
                                        <tr>
                                            <th style={{ 
                                                width: '120px', 
                                                padding: '8px 16px', 
                                                borderBottom: '1px solid #e5e7eb', 
                                                backgroundColor: '#f3f4f6', 
                                                textAlign: 'left', 
                                                color: '#6b7280',
                                                fontWeight: '600'
                                            }}>ထိုးသား</th>
                                            <th style={{ 
                                                width: '120px', 
                                                padding: '8px 16px', 
                                                borderBottom: '1px solid #e5e7eb', 
                                                backgroundColor: '#f3f4f6', 
                                                textAlign: 'right', 
                                                color: '#6b7280',
                                                fontWeight: '600'
                                            }}>ရောင်းကြေး(ယူနစ်)</th>
                                            <th style={{ 
                                                width: '140px', 
                                                padding: '8px 16px', 
                                                borderBottom: '1px solid #e5e7eb', 
                                                backgroundColor: '#f3f4f6', 
                                                textAlign: 'right', 
                                                color: '#6b7280',
                                                fontWeight: '600'
                                            }}>ရောင်းကြေး(ငွေ)</th>
                                            <th style={{ 
                                                width: '100px', 
                                                padding: '8px 16px', 
                                                borderBottom: '1px solid #e5e7eb', 
                                                backgroundColor: '#f3f4f6', 
                                                textAlign: 'right', 
                                                color: '#6b7280',
                                                fontWeight: '600'
                                            }}>ကော်</th>
                                            <th style={{ 
                                                width: '140px', 
                                                padding: '8px 16px', 
                                                borderBottom: '1px solid #e5e7eb', 
                                                backgroundColor: '#f3f4f6', 
                                                textAlign: 'right', 
                                                color: '#6b7280',
                                                fontWeight: '600'
                                            }}>ကော်နှုတ်ပြီး</th>
                                            <th style={{ 
                                                width: '140px', 
                                                padding: '8px 16px', 
                                                borderBottom: '1px solid #e5e7eb', 
                                                backgroundColor: '#f3f4f6', 
                                                textAlign: 'right', 
                                                color: '#6b7280',
                                                fontWeight: '600'
                                            }}>2D(3D)</th>
                                            <th style={{ 
                                                width: '140px', 
                                                padding: '8px 16px', 
                                                borderBottom: '1px solid #e5e7eb', 
                                                backgroundColor: '#f3f4f6', 
                                                textAlign: 'right', 
                                                color: '#6b7280',
                                                fontWeight: '600'
                                            }}>လျော်ကြေး</th>
                                            <th style={{ 
                                                width: '120px', 
                                                padding: '8px 16px', 
                                                borderBottom: '1px solid #e5e7eb', 
                                                backgroundColor: '#f3f4f6', 
                                                textAlign: 'right', 
                                                color: '#6b7280',
                                                fontWeight: '600'
                                            }}>ရ/ပေး</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.keys(groupedStatements).map((customer) => {
                                            const rows = groupedStatements[customer];
                                            const subtotal = rows.reduce(
                                                (acc, row) => {
                                                    acc.discountAmount += parseFloat(row.discountAmount || "0");
                                                    acc.TotalAmountWithDiscount += parseFloat(row.TotalAmountWithDiscount || "0");
                                                    acc.TotalAmountWithoutDiscount += parseFloat(row.TotalAmountWithoutDiscount || "0");
                                                    acc.TotalWinAmountWithoutPrize += parseFloat(row.TotalWinAmountWithoutPrize || "0");
                                                    acc.TotalTAmountWithoutPrize += parseFloat(row.TotalTAmountWithoutPrize || "0");
                                                    acc.TotalAmountWithTPrize += parseFloat(row.TotalAmountWithTPrize || "0");
                                                    acc.TotalAmountWithPrize += parseFloat(row.TotalAmountWithPrize || "0");
                                                    acc.SubTotalAmount += parseFloat(row.SubTotalAmount || "0");
                                                    acc.TotalUnitWithDiscount += parseFloat(row.TotalUnitWithDiscount || "0");
                                                    return acc;
                                                },
                                                {
                                                    discountAmount: 0,
                                                    TotalAmountWithDiscount: 0,
                                                    TotalAmountWithoutDiscount: 0,
                                                    TotalWinAmountWithoutPrize: 0,
                                                    TotalTAmountWithoutPrize: 0,
                                                    TotalAmountWithTPrize: 0,
                                                    TotalAmountWithPrize: 0,
                                                    SubTotalAmount: 0,
                                                    TotalUnitWithDiscount: 0,
                                                }
                                            );

                                            return (
                                                <tr key={customer} style={{ textAlign: 'right' }}>
                                                    <td style={{ 
                                                        width: '120px', 
                                                        padding: '8px 16px', 
                                                        borderBottom: '1px solid #e5e7eb', 
                                                        textAlign: 'left', 
                                                        color: '#111827', 
                                                        fontWeight: '500',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '8px'
                                                    }}>
                                                        {customer}
                                                    </td>
                                                    <td style={{ width: '120px', padding: '8px 16px', borderBottom: '1px solid #e5e7eb', fontWeight: '500' }}>{formatter.format(subtotal.TotalUnitWithDiscount)}</td>
                                                    <td style={{ width: '140px', padding: '8px 16px', borderBottom: '1px solid #e5e7eb', fontWeight: '500' }}>{formatter.format(subtotal.TotalAmountWithDiscount)}</td>
                                                    <td style={{ width: '100px', padding: '8px 16px', borderBottom: '1px solid #e5e7eb', fontWeight: '500' }}>{formatter.format(subtotal.discountAmount)}</td>
                                                    <td style={{ width: '140px', padding: '8px 16px', borderBottom: '1px solid #e5e7eb', fontWeight: '500' }}>{formatter.format(subtotal.TotalAmountWithoutDiscount)}</td>
                                                    <td style={{ width: '140px', padding: '8px 16px', borderBottom: '1px solid #e5e7eb', fontWeight: '500' }}>{formatter.format(subtotal.TotalWinAmountWithoutPrize)}({formatter.format(subtotal.TotalTAmountWithoutPrize)})</td>
                                                    <td style={{ width: '140px', padding: '8px 16px', borderBottom: '1px solid #e5e7eb', fontWeight: '500' }}>{formatter.format(subtotal.TotalAmountWithPrize)}</td>
                                                    <td style={{ 
                                                        width: '120px', 
                                                        padding: '8px 16px', 
                                                        borderBottom: '1px solid #e5e7eb', 
                                                        fontWeight: '500',
                                                        color: subtotal.SubTotalAmount < 0 ? '#dc2626' : '#16a34a'
                                                    }}>{formatter.format(subtotal.SubTotalAmount)}</td>
                                                </tr>
                                            );
                                        })}
                                        {/* Overall Total Row */}
                                        <tr style={{ textAlign: 'right', backgroundColor: '#f9fafb', fontWeight: 'bold' }}>
                                            <td style={{ 
                                                width: '120px', 
                                                padding: '12px 16px', 
                                                borderBottom: '1px solid #d1d5db', 
                                                textAlign: 'left', 
                                                color: '#111827',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px'
                                            }}>
                                                စုစုပေါင်း
                                            </td>
                                            <td style={{ width: '120px', padding: '12px 16px', borderBottom: '1px solid #d1d5db', color: '#111827' }}>{formatter.format(subTotal?.TotalUnitWithDiscount || 0)}</td>
                                            <td style={{ width: '140px', padding: '12px 16px', borderBottom: '1px solid #d1d5db', color: '#111827' }}>{formatter.format(subTotal?.TotalAmountWithDiscount || 0)}</td>
                                            <td style={{ width: '100px', padding: '12px 16px', borderBottom: '1px solid #d1d5db', color: '#111827' }}>{formatter.format(subTotal?.discountAmount || 0)}</td>
                                            <td style={{ width: '140px', padding: '12px 16px', borderBottom: '1px solid #d1d5db', color: '#111827' }}>{formatter.format(subTotal?.TotalAmountWithoutDiscount || 0)}</td>
                                            <td style={{ width: '140px', padding: '12px 16px', borderBottom: '1px solid #d1d5db', color: '#111827' }}>{formatter.format(subTotal?.TotalWinAmountWithoutPrize || 0)}({formatter.format(subTotal?.TotalTAmountWithoutPrize || 0)})</td>
                                            <td style={{ width: '140px', padding: '12px 16px', borderBottom: '1px solid #d1d5db', color: '#111827' }}>{formatter.format(subTotal?.TotalAmountWithPrize || 0)}</td>
                                            <td style={{ 
                                                width: '120px', 
                                                padding: '12px 16px', 
                                                borderBottom: '1px solid #d1d5db',
                                                color: (subTotal?.SubTotalAmount || 0) < 0 ? '#dc2626' : '#16a34a'
                                            }}>{formatter.format(subTotal?.SubTotalAmount || 0)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};



export default Settlements;
